import { useEffect, useState } from "react";
import Header from "../../components/Navigation/Header";
import Cookies from 'js-cookie'
import { ReceiveTestScore } from "../../services/KnowledgeTest";
import { useNavigate } from "react-router-dom";

import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import KnowledgeTestChart from '../../components/charts/knowledgetest';
import PsychometricTestChart from '../../components/charts/pyschometric';

function KnowlegdeTestScore()
{

  const navigate=useNavigate();
  const [score,setScore]=useState();
  const [percentage,setPercentage]=useState();
  useEffect(()=>{
    findScore();
  },[]);

    const findScore=async()=>{
        const response=await ReceiveTestScore(Cookies.get('id'));
        console.log('response',response);
        if(response.success)
        {
          setScore(response.score);
          setPercentage(response.percentage);
        }
    }

        const psychometricRef = useRef(null);
        const knowledgeRef = useRef(null);
    
        const downloadCombinedPDF = async () => {
        const pdf = new jsPDF('landscape', 'pt', 'a4');
        const options = { scale: 1, useCORS: true };
    
        const chart1Canvas = await html2canvas(psychometricRef.current, options);
        const img1 = chart1Canvas.toDataURL('image/png');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (chart1Canvas.height * imgWidth) / chart1Canvas.width;
    
        pdf.addImage(img1, 'PNG', 0, 0, imgWidth, imgHeight);
    
        const chart2Canvas = await html2canvas(knowledgeRef.current, options);
        const img2 = chart2Canvas.toDataURL('image/png');
        const imgHeight2 = (chart2Canvas.height * imgWidth) / chart2Canvas.width;
    
        pdf.addPage();
        pdf.addImage(img2, 'PNG', 0, 0, imgWidth, imgHeight2);
   

        pdf.save('combined_charts.pdf');
    };

    return(
    <>
    <Header/>
      <div className='pyschometrictestcontainer'>
      <section className='pyschometrictext'>
                <h2>Score</h2>
                <h4><span>Home</span><span > &gt; Knowledge Test</span><span style={{color:'#8A090D'}}> &gt; Score</span></h4>
             </section>
             <section className='contextpanel'>
              <div className="container">
              <span className="flex text"><h2>Overall Test Score</h2></span>
              <span className="scoredisplay">
                <div > 
                    <h1>{percentage}%</h1>
                </div>
              </span>
              <span className="buttonsection">
                     <button onClick={downloadCombinedPDF}>DOWNLOAD REPORT</button>
                   <button onClick={()=>navigate('/viewdetailedreport')}>VIEW DETAILED REPORT</button>
              </span>
                 <div className="offscreen-render">
                  <div ref={psychometricRef}>
                    <PsychometricTestChart />
                  </div>
                  <div ref={knowledgeRef}>
                    <KnowledgeTestChart />
                  </div>
              </div>
              </div>
              </section>
      </div>
    </>);
}

export default KnowlegdeTestScore;